require('./dashboard-node.component.scss');

class DashboardNodeController {
  constructor(
    $scope,
    $element,
    $q,
    CurrentFilterService,
    PermissionService,
    LayoutService,
    RouterService,
    FilterDataFactory,
    CurrentModelService,
    FilterEditorService,
    FiltersService,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$q = $q;
    this.CurrentFilterService = CurrentFilterService;
    this.permission = PermissionService;
    this.layout = LayoutService;
    this.router = RouterService;
    this.CurrentModelService = CurrentModelService;
    this.FilterEditorService = FilterEditorService;
    this.FiltersService = FiltersService;
    this.filterData = FilterDataFactory();
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get filter() {
    return this._filter;
  }

  set filter(filter) {
    this._filter = filter;
    this.filterData.update(filter);
  }

  get filterBar() {
    return this.CurrentFilterService.filterBar;
  }

  editFilter() {
    let filter = this.FiltersService.findById(this.filter.id);
    return this.$q.resolve()
      .then(() => {
        return this.FilterEditorService.editModal({
          filter,
          asNew       : false,
          selectFilter: false,
        });
      })
      .then(newFilter => {
        if (!newFilter) {
          return;
        }
        Object.assign(this.filter, newFilter);
      });
  }

  getViewHeight() {
    let height = this.dashboard.getHeightPx(this.filter);
    if(!height) {
      return 'auto';
    }
    return (height - this.$element.find('h4').outerHeight(true) - 16) + 'px';
  }
}

export const DashboardNodeComponent = {
  template  : require('./dashboard-node.component.html'),
  require: {dashboard: '^scDashboard'},
  bindings  : {
    filter: '<',
  },
  controller: DashboardNodeController,
};



// WEBPACK FOOTER //
// ./src/view/dashboard/dashboard-node.component.js